import { disableScroll } from '../functions/disable-scroll.js';
import { enableScroll } from '../functions/enable-scroll.js';

function initBurger() {
    const burger = document.querySelector('[data-burger]');
    const menu = document.querySelector('[data-menu]');
    const overlay = document.querySelector('[data-menu-overlay]');

    if (!burger || !menu) {
        return;
    }

    const menuItems = menu.querySelectorAll('[data-menu-item]');

    burger.addEventListener('click', () => {
        const isOpen = menu.classList.toggle('menu--active');

        if (isOpen) {
            burger.setAttribute('aria-expanded', 'true');
            burger.setAttribute('aria-label', 'Закрыть меню');
            menu.setAttribute('aria-hidden', 'false');
            disableScroll();
        } else {
            burger.setAttribute('aria-expanded', 'false');
            burger.setAttribute('aria-label', 'Открыть меню');
            menu.setAttribute('aria-hidden', 'true');
            enableScroll();
        }
    });

    overlay?.addEventListener('click', () => {
        burger.setAttribute('aria-expanded', 'false');
        burger.setAttribute('aria-label', 'Открыть меню');
        menu.classList.remove('menu--active');
        menu.setAttribute('aria-hidden', 'true');
        enableScroll();
    });

    menuItems.forEach((el) => {
        el.addEventListener('click', () => {
            burger.setAttribute('aria-expanded', 'false');
            burger.setAttribute('aria-label', 'Открыть меню');
            menu.classList.remove('menu--active');
            menu.setAttribute('aria-hidden', 'true');
            enableScroll();
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBurger);
} else {
    initBurger();
}
